export default String.raw`
@media only screen and (max-width: 1279px) {

  @media (hover: none) {
    a:hover {
      color: inherit;
      background: inherit;
    }
  }

  input[name=phoneNo]{
    max-width: 100%;
  }
  
  .message-popup-background{
    padding: 0;
  }

  // Header
  .editing-info{
    width: calc(100% - 120px);
    font-size: 14px;
    line-height: 1.5;
    margin-top: 6px;
    i{
      font-size: 15px;
    }
  }

  // Blog
  .blog-posts-list-js{
    width: 100%;
    padding: 0;
  }

  // Products List
  .products-page-js{
    padding: 0;
    &.no-category{
      margin-top: 20px;
    }
    h2{
      margin: 0 20px 20px 20px;
    }
  }

  .category-info-js{
    margin: 20px 0 50px;
    position: absolute;
    top: -114px;
  }


  .grid-slider-js{
    display: none !important;
  }

  .position-attributes-set-form-js{
    width: calc(100% - 100px);
    float: right;
  }

  .maps-container-js{
    padding: 20px 0;
  }

  .cart-products-table-js .multiplicity-info-js{
    font-size: 10px;
    width: 80px;
    margin-top: 60px;
    line-height: 1;
    span{
      float: none !important;
    }
  }
}
`